import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { Fax } from '../../../models/fax';

import { FaxService } from '../../../services/outgoing/fax.service';

@Component({
  selector: 'app-fax-index',
  templateUrl: './fax-index.component.html',
  styleUrls: ['./fax-index.component.scss'],
})
export class FaxIndexComponent implements OnInit, OnDestroy {
  incomingFaxes: Array<Fax> = [];

  loading: boolean = true;

  outgoingFaxes: Array<Fax> = [];

  /**
   * Subscription to router events to catch page changes and fax id changes in the URL
   * @type {Subscription}
   */
  routerEventsSubscription: Subscription;

  selectedFax: Fax;

  /**
   * Modal object
   * @type {BsModalRef}
   */
  viewModalRef: BsModalRef;

  /**
   * Fax show dialog ref
   * @param {[type]} 'fax_show' fax show dialog ref
   */
  @ViewChild('fax_show', { static: true }) faxShowDialog: TemplateRef<any>;

  constructor(private activatedRoute: ActivatedRoute, private modalService: BsModalService, private faxService: FaxService, private router: Router) {
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      if (this.activatedRoute.snapshot.params.id) this.viewFax(this.activatedRoute.snapshot.params.id, this.faxShowDialog);
    });
  }

  ngOnInit() {
    this.loadFaxes();
  }

  ngOnDestroy() {
    if (this.viewModalRef) this.viewModalRef.hide();
    if (this.routerEventsSubscription) this.routerEventsSubscription.unsubscribe();
  }

  viewFax(fax_id: number, template: TemplateRef<any> | null = null, config: any = { backdrop: true, ignoreBackdropClick: false }) {
    this.faxService.show(fax_id).then((response_json) => {
      this.selectedFax = response_json.fax;
      if(template){
        this.viewModalRef = this.modalService.show(template, config);
      }
    });
  }

  loadFaxes() {
    this.loading = true;
    this.faxService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.incomingFaxes = response_json.incoming_faxes;
        this.outgoingFaxes = response_json.outgoing_faxes;
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
